import { apiSlice } from './apiSlice';

const NEWS_URL = '/api/news';

export const newsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNewsPosts: builder.query({
      query: () => ({
        url: NEWS_URL,
        method: 'GET',
      }),
      providesTags: ['News'],
    }),
    getNewsPostBySlug: builder.query({
      query: (slug) => ({
        url: `${NEWS_URL}/${slug}`,
        method: 'GET',
      }),
      providesTags: (result, error, slug) => [{ type: 'News', id: slug }],
    }),
    getAdminNewsPosts: builder.query({
      query: () => ({
        url: `${NEWS_URL}/admin`,
        method: 'GET',
      }),
      providesTags: ['NewsAdmin'],
    }),
    getAdminNewsPostById: builder.query({
      query: (id) => ({
        url: `${NEWS_URL}/id/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'NewsAdmin', id }],
    }),
    createNewsImageUpload: builder.mutation({
      query: (body) => ({
        url: `${NEWS_URL}/uploads/presign`,
        method: 'POST',
        body,
      }),
    }),
    createNewsPost: builder.mutation({
      query: (body) => ({
        url: NEWS_URL,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['NewsAdmin', 'News'],
    }),
    updateNewsPost: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${NEWS_URL}/id/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['NewsAdmin', 'News'],
    }),
    publishNewsPost: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${NEWS_URL}/id/${id}/publish`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['NewsAdmin', 'News'],
    }),
    generateReleaseDraft: builder.mutation({
      query: (body) => ({
        url: `${NEWS_URL}/generate-release-draft`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['NewsAdmin'],
    }),
    createNewsComment: builder.mutation({
      query: ({ postId, body }) => ({
        url: `${NEWS_URL}/id/${postId}/comments`,
        method: 'POST',
        body: { body },
      }),
      invalidatesTags: ['News', 'NewsAdmin'],
    }),
    moderateNewsComment: builder.mutation({
      query: ({ commentId, status }) => ({
        url: `${NEWS_URL}/comments/${commentId}/moderate`,
        method: 'POST',
        body: { status },
      }),
      invalidatesTags: ['News', 'NewsAdmin'],
    }),
    sendContactMessage: builder.mutation({
      query: (body) => ({
        url: '/api/mail/contact',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useCreateNewsCommentMutation,
  useCreateNewsImageUploadMutation,
  useCreateNewsPostMutation,
  useGenerateReleaseDraftMutation,
  useGetAdminNewsPostByIdQuery,
  useGetAdminNewsPostsQuery,
  useGetNewsPostBySlugQuery,
  useGetNewsPostsQuery,
  useModerateNewsCommentMutation,
  usePublishNewsPostMutation,
  useSendContactMessageMutation,
  useUpdateNewsPostMutation,
} = newsApiSlice;
